import React from 'react';
import styles from '../Form.module.scss';
// @ts-ignore
import classNames from 'classnames';

enum FormGroupVariant {
  Inline = 'Inline',
  Block = 'Block',
}

type FormGroupPropsType = {
  children: React.ReactNode;
  variant?: FormGroupVariant;
  className?: string;
  isError?: boolean;
};

const FormGroup = (props: FormGroupPropsType) => {
  return (
    <div
      className={classNames(
        styles.formGroupWrapper,
        props.className,
        props.variant ? styles[`formGroup${props.variant}`] : styles.formGroupBlock,
        props.isError && styles.isError,
      )}
    >
      {props.children}
    </div>
  );
};

FormGroup.Variants = FormGroupVariant;

export default FormGroup;
